import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { Subject, takeUntil } from 'rxjs';
import { SignatureBoxFilter } from '../../../model/signatureDocumentUsers';
import { ClientService } from '../../../services/client.service';
import { Client } from '../../../model/client';
import * as _ from 'lodash';

@Component({
    selector: 'app-signature-box-filter',
    templateUrl: './signature-box-filter.component.html',
    styleUrls: ['./signature-box-filter.component.scss'],
    standalone: false,
})
export class SignatureBoxFilterComponent implements OnInit {

  @Output() filterEmitter = new EventEmitter<SignatureBoxFilter>();
  typeSigners: any[] = [{id: 1, translation: 'protocol'}, {id: 2, translation: 'reviewedBy'}, {id: 3, translation: 'approvedBy'}];
  typeDocuments: any[] = [{id: 1, translation: 'protocolQualification'}];
  typeDocumentsFiltered: any[];
  filter: SignatureBoxFilter = new SignatureBoxFilter();
  clients: Client[];
  clientsFiltered: Client[];
  form: FormGroup;
  expandedFilter = true;
    
  private destroy$ = new Subject<void>();
  constructor(fb: FormBuilder,
    private clientService: ClientService) {
    this.form = fb.group({
      idClient: [this.filter.idClient],
      documentCode: [this.filter.documentCode],
      idStatus: [this.filter.idStatus],
      idType: [this.filter.idType],
      username: [this.filter.username]
    });

  }

  ngOnInit(): void {
    this.typeDocumentsFiltered = _.cloneDeep(this.typeDocuments);
    this.clientService.findAll().pipe(takeUntil(this.destroy$)).subscribe((data: Client[]) => {
      const empty = new Client();
      empty.id = null;
      empty.name = '---';

      data = [empty].concat(data);

      this.clients = data;
      this.clientsFiltered = this.clients.slice();
    });
  }

  doFilter(): void {
    this.expandedFilter = false;

    this.filterEmitter.emit(this.filter);
  }

  cleanFilter() {
    
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }


}
